const DASHBOARD_METRIC_LABELS: Record<string, string> = {
	ggr: 'GGR',
};

export const getDashboardMetricName = (key: string) =>
	DASHBOARD_METRIC_LABELS[key] ?? `${key.charAt(0).toUpperCase()}${key.slice(1)}`;
